export type NOTIFICATION_APPEARANCE = "error" | "info" | "success" | "warning";

export enum APPEARANCE {
  ERROR = "error",
  SUCCESS = "success",
}
